<script setup>
import VisitorRegistrationDialog from '@/views/care-visit/VisitorRegistrationDialog.vue'
import CustomerTable from '@/views/care-visit/customer/CustomerTable.vue'
import VisitorPassDialog from '@/views/care-visit/VisitorPassDialog.vue'
import EpisodeDrawer from '@/views/common/EpisodeDrawer.vue'

definePage({
  meta: {
    name: "Customer Management",
    subject: "care_visit.menu",
    action: "customer",
  },
})

const refTable = ref()

const episodeData = ref(null)

const showGenerateVisitorPassDialog = ref(false)

watch(() => showGenerateVisitorPassDialog.value, value => {
  if (value === false) {
    episodeData.value = null
  }
})


const showVisitorPassDialog = ref(false)
const visitorPassData = ref(null)

watch(() => showVisitorPassDialog.value, value => {
  if (value === false) {
    episodeData.value = null
    visitorPassData.value = null
  }
})

// Episode Drawer
const isEpisodeDrawerVisible = ref(false)
const selectedEpisode = ref(null)

const handleViewEpisode = episode => {
  selectedEpisode.value = episode
  isEpisodeDrawerVisible.value = true
}
</script>

<template>
  <VRow>
    <VCol cols="12">
      <CustomerTable
        ref="refTable"
        @generate-visitor-pass="item => {
          episodeData = item
          showGenerateVisitorPassDialog = true
        }"
        @visitor-pass="(episode, visitorPass) => {
          episodeData = episode
          visitorPassData = visitorPass
          showVisitorPassDialog = true
        }"
        @view-episode="handleViewEpisode"
      />
    </VCol>
  </VRow>

  <VisitorRegistrationDialog
    v-model:isDialogOpen="showGenerateVisitorPassDialog"
    :episode-data="episodeData"
    @saved="() => refTable.fetchEpisodes()"
  />

  <VisitorPassDialog
    v-model:isDialogOpen="showVisitorPassDialog"
    :episode-data="episodeData"
    :visitor-pass-data="visitorPassData"
  />

  <EpisodeDrawer
    v-model:is-drawer-open="isEpisodeDrawerVisible"
    :episode="selectedEpisode"
  />
</template>
